import * as types from "../types";

const initialState = {
  loading: false,
  instAttempts: null,
  requestDevice: null,
  error: null,
};

export default function fetchInstAttemptsReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_INST_ATTEMPTS_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_INST_ATTEMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        instAttempts: action.payload.instAttempts,
      };

    case types.FETCH_INST_ATTEMPTS_FAILURE:
      return {
        ...state,
        loading: false,
        instAttempts: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
